var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    { staticClass: "infinite-list-item", on: { click: _vm.selectedItem } },
    [
      _c("ResaltarTexto", {
        attrs: { texto: _vm.label, busqueda: _vm.$parent.text },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }